import { render, staticRenderFns } from "./AplicacionSubTab.vue?vue&type=template&id=4825f310&"
import script from "./AplicacionSubTab.vue?vue&type=script&lang=js&"
export * from "./AplicacionSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports